/**
 * Іконки — CSS-маски з data URI (styles/icons.css, перенесено з макетів): 0 КБ JS,
 * ≈ 2.4 КБ gzip CSS на весь набір, колір — currentColor. Завжди декоративні: сенс несе
 * текст поруч або aria-label кнопки (components.md, розд. 2).
 */
export type IconName =
  | 'phone'
  | 'search'
  | 'plus'
  | 'bell'
  | 'check'
  | 'calendar'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevron-left'
  | 'list'
  | 'user'
  | 'users'
  | 'building'
  | 'briefcase'
  | 'home'
  | 'task'
  | 'more'
  | 'close'
  | 'clock'
  | 'note'
  | 'mail'
  | 'lock'
  | 'warning'
  | 'alert-circle'
  | 'refresh'
  | 'sort-down'
  | 'check-circle'
  | 'x-circle'
  | 'inbox'
  | 'edit'
  | 'file'
  | 'history'
  | 'wifi-off'
  | 'menu'
  | 'kanban'
  | 'settings'
  | 'merge'
  | 'trash';

export function Icon({ name, size }: { name: IconName; size?: 20 }) {
  return (
    <i className={size === 20 ? `ic ic--20 ic-${name}` : `ic ic-${name}`} aria-hidden="true" />
  );
}
